import { styled } from 'styled-components'

import { KnownPlatform } from '../../model'
import BINANCE_ICON from '../assets/Binance.inline.png'
import BINANCE_US_ICON from '../assets/Binance_US.inline.png'
import BIT_MART_ICON from '../assets/BitMart.inline.png'
import BITFINEX_ICON from '../assets/Bitfinex.inline.png'
import BITGET_ICON from '../assets/Bitget.inline.png'
import BITHUMB_ICON from '../assets/Bithumb.inline.png'
import BITSTAMP_ICON from '../assets/Bitstamp.inline.png'
import BYBIT_ICON from '../assets/Bybit.inline.png'
import CHANGE_NOW_ICON from '../assets/ChangeNow.inline.png'
import CHANGELLY_ICON from '../assets/Changelly.inline.png'
import COIN_EX_ICON from '../assets/CoinEx.inline.png'
import COINBASE_ICON from '../assets/Coinbase.inline.png'
import CRYPTOCOM_ICON from '../assets/Cryptocom.inline.png'
import FALCON_X_ICON from '../assets/FalconX.inline.png'
import FIXED_FLOAT_ICON from '../assets/FixedFloat.inline.png'
import GATE_ICON from '../assets/Gate.inline.png'
import GEMINI_ICON from '../assets/Gemini.inline.png'
import HUOBI_ICON from '../assets/Huobi.inline.png'
import KRAKEN_ICON from '../assets/Kraken.inline.png'
import KUCOIN_ICON from '../assets/KuCoin.inline.png'
import LBANK_ICON from '../assets/LBank.inline.png'
import MEXC_ICON from '../assets/MEXC.inline.png'
import OKX_ICON from '../assets/OKX.inline.png'
import POLONIEX_ICON from '../assets/Poloniex.inline.png'
import REVOLUT_ICON from '../assets/Revolut.inline.png'
import STAKE_ICON from '../assets/Stake.inline.png'
import UPBIT_ICON from '../assets/Upbit.inline.png'
import XT_ICON from '../assets/XT.inline.png'

import type { Address } from '@root/entities/address/Address'

type KnownPlatformIconProps = {
  size?: number
} & ({ knownPlatform: KnownPlatform.KnownPlatform } | { address: Address })

export const KnownPlatformIcon = ({
  size = 24,
  ...props
}: KnownPlatformIconProps) => {
  const knownPlatform =
    'knownPlatform' in props
      ? props.knownPlatform
      : KnownPlatform.tryGetKnownPlatform(props.address)

  if (!knownPlatform) {
    return undefined
  }

  return (
    <Root
      src={ICON_MAP[knownPlatform]}
      alt={knownPlatform}
      width={size}
      height={size}
    />
  )
}
const Root = styled.img`
  display: block;
`

const ICON_MAP: Record<KnownPlatform.KnownPlatform, string> = {
  Binance: BINANCE_ICON,
  'Binance US': BINANCE_US_ICON,
  Bithumb: BITHUMB_ICON,
  BitMart: BIT_MART_ICON,
  Bitfinex: BITFINEX_ICON,
  Bitget: BITGET_ICON,
  Bitstamp: BITSTAMP_ICON,
  Bybit: BYBIT_ICON,
  CoinEx: COIN_EX_ICON,
  Coinbase: COINBASE_ICON,
  Cryptocom: CRYPTOCOM_ICON,
  FalconX: FALCON_X_ICON,
  Gate: GATE_ICON,
  Gemini: GEMINI_ICON,
  Huobi: HUOBI_ICON,
  Kraken: KRAKEN_ICON,
  KuCoin: KUCOIN_ICON,
  LBank: LBANK_ICON,
  MEXC: MEXC_ICON,
  OKX: OKX_ICON,
  Poloniex: POLONIEX_ICON,
  Revolut: REVOLUT_ICON,
  Upbit: UPBIT_ICON,
  XT: XT_ICON,
  FixedFloat: FIXED_FLOAT_ICON,
  Stake: STAKE_ICON,
  Changelly: CHANGELLY_ICON,
  ChangeNow: CHANGE_NOW_ICON,
}
